var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
        [
          _c("v-text-field", {
            attrs: {
              value: _vm.user.name + " " + _vm.user.surname,
              label: _vm.$t("global.nameAndSurname"),
              readonly: ""
            }
          })
        ],
        1
      ),
      _vm.user.phone != null && _vm.user.phone.length > 0
        ? _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.user.phone,
                  label: _vm.$t("global.phone"),
                  readonly: ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user.birth_date != null && _vm.user.birth_date.length > 0
        ? _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.user.birth_date,
                  label: _vm.$t("user.birthDate"),
                  readonly: ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user.email != null && _vm.user.email.length > 0
        ? _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { value: _vm.user.email, label: "Email", readonly: "" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user.document_number != null && _vm.user.document_number.length > 0
        ? _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.user.document_number,
                  label: _vm.$t("user.documentNumber"),
                  readonly: ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user.document_expire != null && _vm.user.document_expire.length > 0
        ? _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.user.document_expire,
                  label: _vm.$t("user.documentExpire"),
                  readonly: ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user.document_issue_place != null &&
      _vm.user.document_issue_place.length > 0
        ? _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.user.document_issue_place,
                  label: _vm.$t("global.documentIssuePlace"),
                  readonly: ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user.residence_address != null &&
      _vm.user.residence_address.length > 0
        ? _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.user.residence_address,
                  label: _vm.$t("global.residenceAddress"),
                  readonly: ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user.nationality != null && _vm.user.nationality.length > 0
        ? _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.user.nationality,
                  label: _vm.$t("global.nationality"),
                  readonly: ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.user.middle_name != null && _vm.user.middle_name.length > 0
        ? _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  value: _vm.user.middle_name,
                  label: _vm.$t("global.middleName"),
                  readonly: ""
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }